
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Це стало можливим завдяки проєкту
                    <a href="${0}">Folksonomy Engine</a>. Не соромтеся
                    брати участь або залишати відгуки`,
'h5d824b4954e56ea5': html`Скануйте свої <span class="everyday">щоденні</span> <span class="foods">продукти харчування</span>`,
'h6bdd1b427aa985a4': html`Цей інструмент дозволяє вам виправляти список інгредієнтів. Ви можете додавати, видаляти або редагувати
                список інгредієнтів.
                <br>
                Цей символ <span class="highlight">␣</span> позначає пробіл.
                <br>
                Цей символ <span class="highlight">↩︎</span> позначає розрив рядка. `,
'hb28f1f2ec1744ee9': html`Ці властивості створюються та зберігаються користувачами для будь-якого використання. Не соромтеся додавати свої власні
                    . Властивості та значення, які ви створюєте
                    <strong>, мають бути фактичними</strong>. Ви можете заглибитися в
                    <a href="${0}">список властивостей, які вже використовуються спільнотою</a>
                    або ознайомитися з документацією властивостей
                    <a href="${1}">та їх пошуковою системою</a>.`,
's000a5b76bd3a01c2': `Завантаження властивостей...`,
's000d98595e959c1e': `Завантажити з Google Play`,
's013bdc8cf0d3583d': `Допоможіть нам з інгредієнтами`,
's01d2865e3e1d5501': `Дякую за вашу допомогу!`,
's02ce7a2e7c1b020b': `Перевірити врожай`,
's03e9c8114521b998': `Я відредагую інгредієнти`,
's05ec315d9308091a': `Значок кутів штрих-коду`,
's061eb5af92512c85': `Збережено! Чи можете допомогти з іншим?`,
's06847c221c4c0bc1': `Я хотів би створити властивість для [опишіть ваш варіант використання]...`,
's06f6c6f99db6b552': `Оригінал`,
's081e2ad82db71e1d': `Згруповані значення`,
's09205907b5b56cda': `Ні`,
's0b4235aae602a950': `спеціалізована документація`,
's0bb2d48532acc455': `Завантажити CSV-файл`,
's0d5b7fee0311db68': `Властивість`,
's0fb218abc2e157ed': `Зробити зображення недійсним`,
's100c4928cc74642a': `підтримуємо розвиток досліджень громадського здоров'я.`,
's10db5498186c083b': `Скасувати обрізання`,
's11a18a69b30b65ed': `Допоможіть нам виправити помилки у списку інгредієнтів`,
's1205d5f6fccf8e69': `Вартість нерухомості`,
's15d64a0a6715285a': `Новий ключ`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Область вибору`,
's1a52515ec8ddade8': `Штрих-код продукту`,
's1c5031113de500ce': `підтримуючи нашу базу даних відкритою &amp; доступною для всіх,`,
's1dc4daf989c71284': `Допоможіть нам виправити інформацію про харчову цінність`,
's1e00019dc454872d': `Будь ласка, вкажіть назву властивості, використовуючи атрибут property-name.`,
's1e49126af0935a5b': `Список продуктів, що використовують цю властивість`,
's21e73088de6f26f3': `Завантажити із App Store`,
's255857544a9d5ec0': `Скинути`,
's25e94495991e95ba': `Дякуємо за допомогу! Чи можете ви допомогти з іншим запитанням?`,
's2ceb11be2290bb1b': `Відмінити`,
's2db7b654c0a9bde0': `Документуйте майно`,
's300b3a6ee4e1252d': str`Погана відповідність ${0}%`,
's33f786bb6b4f0cf4': `Результат обрізки`,
's33f85f24c0f5f008': `Зберегти`,
's34be4af4e8fec4ae': `Спочатку запитайте у громади`,
's36d86adc823cbfa6': `Перш ніж створювати новий об'єкт нерухомості, обговоріть його зі спільнотою:`,
's3781d25aa51a736c': `Документація двигуна Folksonomy`,
's383ae4449428b61e': `Скинути обрізку`,
's39bcf88721a1e8ee': `Скинути вибір`,
's39e14e14300694c7': `Документація та інструкції`,
's3b430cfa5c1fe7f4': str`Документація для ${0}`,
's3f4e4b52f230a892': `Полотно зображення`,
's417b90913e05bc17': `Попередній перегляд`,
's41f7dca46d3f1b4a': `Цінність`,
's422bba9636ce2489': `Центр зображення`,
's42dd66b2441566fd': `Значок центру`,
's43df2e8395f6834e': str`Будь ласка, долучіться до нашого ${0} збору коштів`,
's453188ea728f64da': `Додати поживну речовину`,
's453ab0dbb9b5c777': `Змінити розмір праворуч`,
's475b08749d0706ed': `Допоможіть нам інформувати мільйони споживачів по всьому світу про те, що вони їдять`,
's49730f3d5751a433': `Завантаження...`,
's4bbc7472834a9686': `Ваш браузер не підтримує сканування штрих-кодів.`,
's4d42cc7e00076a3b': `Кількість продуктів`,
's4df2f533c0c1e7d0': `Елементи керування зображеннями`,
's4e94adf723979402': `Open Food Facts потребує вашої допомоги з цим продуктом.`,
's4f4886341969d552': `Перемістити виділення`,
's4f751fb9b3ed766c': `Створення нової власності`,
's547c12ae169d00bc': `Доступно на F-Droid`,
's5560fb119e40923d': `Введіть назву власності...`,
's55d7249883a98ca1': `про цю власність на вікі Open Food Facts`,
's565867d84c04aea2': `Властивості фільтра...`,
's5666afe5cd0166de': `Будь ласка, виправте помилки або змініть текст перед підтвердженням`,
's57472465a23b41db': `Цінності`,
's58e1eeea7a60ae51': `Завантаження товарів...`,
's59df20feee978e5b': `Помилка: недійсне значення.`,
's5c92c0051d44b6de': `Допоможіть нам виправити інформацію про харчову цінність.`,
's5dd6f12783fca34f': `Редагувати список інгредієнтів`,
's5e8250fb85d64c23': `Закрити`,
's5ed03bb1f3a15949': `Зображення`,
's6306a31415aea913': `Я ПІДТРИМУЮ`,
's6498dfe4855bb3a7': `одиниць`,
's64ef2a6c2dd1d3d1': `Редагувати`,
's66413c24dcf680e2': `Пропустити`,
's67ae6594857a4d57': `Дякуємо за Ваш внесок!`,
's6cee7cad81dfedd1': `Обрізане зображення`,
's6d7b6cdedaadfb6e': `Кожна пожертва має значення! Ми цінуємо вашу підтримку в забезпеченні подальшої прозорості харчових продуктів у світі.`,
's7124dde792a8faa2': `АРК для Android`,
's718dea04853f80ae': str`Гарний збіг ${0}%`,
's71a5c9f4b68ef4d4': `К-сть`,
's74cb3d66f6a668e1': `Документація`,
's787dd11bed0dc88a': `Змінити розмір ліворуч`,
's7ce4fd9430e80cea': `вартість`,
's801a05fa8e881f37': `Дізнайтеся більше про створення власності та правила:`,
's8038273de2cf8b73': `Будь ласка, виберіть область для обрізання.`,
's839cc2908a5387f2': `Фільтрувати штрих-коди...`,
's86197dcf3e96af64': `Переглядайте та шукайте існуючі об'єкти нерухомості`,
's8a63be30a129a59c': `Змінити розмір нижньої частини`,
's8a8bfd67f2dd2810': `Завантажте програму OFF за допомогою цього QR-коду`,
's8af61807443f32a4': `Дії`,
's8b33c244759d7bd4': `Змінити розмір верхнього правого кута`,
's8db84aa4bc949af2': `Документуйте нову власність`,
's8f839a03997a16d7': `Переглянути продукт`,
's901ae1e236ac45d3': `Скасувати видалення`,
's907f7a97c6b29425': `Майте на увазі, що модель даних може бути змінена. Використовуйте на свій страх і ризик.`,
's95d23d03f9147581': `Зменшити масштаб`,
's976dfd19ef58a1e1': `Клацніть, щоб відсканувати штрих-код і дізнатися його деталі (здоров’я, уподобання тощо)`,
's98ff35f2a00dc60d': `Інгредієнти:`,
's9a7f60fce090ecaf': `Не вдалося завантажити властивості. Спробуйте пізніше.`,
's9b87abd68fb9df45': `Не знайдено? Створіть новий ключ {value}`,
's9c0f52425fd2f07e': `Може не збігатися`,
's9fc41f789c63b40d': `Товари`,
'sa1fa766e0d5634d7': `Немає оцінок`,
'sa548778b24054030': `Перегляньте всі надані властивості з проєкту Folksonomy Engine. Ці властивості надають додаткові метадані та інформацію про продукти в базі даних Open Food Facts.`,
'sa63907958bd0ec4b': `Змінити розмір верхнього лівого кута`,
'sa95b4224f685a36a': `Закрити модальне вікно`,
'sab56a1d439576fd6': `Значок пропозиції`,
'sac47ea2901d04c15': `Змінити розмір нижнього лівого кута`,
'sb125227d436c2925': `Знайдіть свою концепцію нерухомості в існуючій базі даних нерухомості:`,
'sb125568d43642e6f': `Дайте відповіді на запитання щодо продукту.`,
'sb1c538e038f9b214': str`Дуже хороший збіг ${0}%`,
'sb28639570ff3b852': `список усіх об'єктів нерухомості`,
'sb3bdd638a58d30f4': `залучаємо спільноту відданих громадян,`,
'sb3cbcc1bd0fff140': `Після того, як ви переконаєтеся, що вашої власності не існує, і спільнота погодиться з її корисністю, вам потрібно спочатку задокументувати її у вікі.`,
'sb3d4f79d9d8b71e5': `Підтвердити`,
'sb560fa37a7bfb6c2': `Для цієї власності не знайдено жодних товарів.`,
'sb7f72e4c8a2d3357': `Фільтрувати значення...`,
'sb8178320160f84ea': `Показати обрізку`,
'sbad7d2734149470b': `Перевірити`,
'sbb623d6b18d966a0': `Харчова цінність вказана на упаковці:`,
'sbd6be5cde472f37c': `На всі запитання є відповіді! Дякую за вашу допомогу!`,
'sbd9a0b2293b3cd3c': `Розмір порції`,
'sbe472dc3c2685985': `Відповідне значення`,
'sc0520e1732a5c568': `Розгорнути зображення`,
'sc0cc559e7ede852a': `Змінити розмір верхньої частини`,
'sc1c08d0cbcc3bd24': `Не збігається`,
'sc52696641af72b53': `Встановіть додаток!`,
'sc5575e3107f87874': `Повернути зображення ліворуч`,
'sc57b630a7a70c61f': `Пропоноване виправлення`,
'sc681b137e8f604f7': `Підтвердити видалення`,
'sc6daf8a31883f8b9': `Перемістити зображення`,
'sc895972c88d38ca5': `власність фолксономії`,
'sca0c3305aff570b8': str`за вказану порцію "${0}"`,
'scace072bef961918': `Рядки`,
'scb3b0671d7b7f640': `Нове значення`,
'scb489a1a173ac3f0': `Так`,
'scbab4bd737ba7934': str`групове фото пожертвуваннь ${0}`,
'scd21019c3cd618f3': `Приєднатися до обговорення Slack`,
'scdb6cad0b92721bf': `Не знайдено жодної власності.`,
'scf23a05631f93732': `Підтвердити видалення`,
'scfed2f270ef6a3aa': `Виберіть область`,
'sd1022bc1ef9204f7': `Зображення, що масштабується`,
'sd1077c055cf9ba6b': `Допоможіть нам перевірити список інгредієнтів продукту.`,
'sd698d21ddecba56b': `Привіт! Ви можете допомогти нам покращити інформацію про продукт, відповівши на такі запитання:`,
'sd82bc2decefa621b': `залишаємося незалежними від харчової промисловості,`,
'sdb97e5976482606e': `Перевірте, чи властивість вже існує`,
'sdbf806fefc584115': `Вам слід знайти`,
'sdc673e73b5c13aea': `Видалити`,
'sdc792b75f1edcaba': `Допоможіть нам виправити правопис інгредієнтів.`,
'sdca5deead576ceee': `Змінити розмір нижнього правого кута`,
'sdcc2555c5dde524f': `Ви впевнені, що хочете видалити цей елемент? Цю дію не можна скасувати.`,
'se206feec7ec57b28': `на 100 г.`,
'se419a9ab36987490': `Визнати недійсним`,
'se5127cf0f92e7e48': `Порада: ви також можете знайти`,
'se773f50d2a16d481': `Повернути зображення праворуч`,
'sebb2c6c830a44574': `технічна інфраструктура (веб-сайт/мобільний додаток) &amp; невелика постійна команда`,
'sec6377f3c4e9b28c': `Я запропоную кращий урожай`,
'seea3800e27baa686': `Окремі продукти`,
'sefaba4adc4ec9219': `Властивості Фолксономії`,
'seffa8ca49175b5f0': `Персоналізовані властивості`,
'sf44a6b3b232c28ea': str`Замініть поточне значення на ${0}`,
'sf4cd86a2f5ef2588': `Штрих-код продукту`,
'sf57a61152168cc81': `Допоможіть нам виправити виявлення інгредієнтів`,
'sf88b90b8ba23871c': `Невідомий збіг`,
'sf9aee319a006c9b4': `Додати`,
'sfacbbe968fa7d773': `Назва об'єкта нерухомості:`,
'sfc40ea3d5d5aa6f8': `Ваші пожертви фінансують щоденні операції з нашої неприбуткової асоціації:`,
'sfe87465d50530725': `Відповідне значення`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  